// ============================================================
// ScoreRing — SVG circular progress ring showing deal score
// Props:
//   score    {number}  0–100
//   grade    {string}  A / B / C / D / F
//   size     {number}  diameter in px (default 52)
//   showLabel {bool}   show score number inside ring (default true)
// ============================================================
import React from "react";

const GRADE_COLOR = {
  A: "#16a34a",  // green
  B: "#2563eb",  // blue
  C: "#d97706",  // amber
  D: "#ea580c",  // orange
  F: "#dc2626",  // red
};

export default function ScoreRing({ score = 0, grade = "F", size = 52, showLabel = true }) {
  const radius    = (size - 6) / 2;   // 3px stroke on each side
  const circ      = 2 * Math.PI * radius;
  const filled    = circ * (score / 100);
  const color     = GRADE_COLOR[grade] || "#94a3b8";
  const center    = size / 2;
  const fontSize  = Math.round(size * 0.28);
  const gradeSize = Math.round(size * 0.18);

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      style={{ flexShrink: 0 }}
      aria-label={`Deal score ${score}, grade ${grade}`}
    >
      {/* Background track */}
      <circle
        cx={center} cy={center} r={radius}
        fill="none"
        stroke="#e2e8f0"
        strokeWidth={4}
      />
      {/* Progress arc */}
      <circle
        cx={center} cy={center} r={radius}
        fill="none"
        stroke={color}
        strokeWidth={4}
        strokeLinecap="round"
        strokeDasharray={`${filled} ${circ - filled}`}
        strokeDashoffset={circ / 4}   /* start from 12-o'clock */
        transform={`rotate(-90 ${center} ${center})`}
        style={{ transition: "stroke-dasharray 0.5s ease" }}
      />
      {showLabel && (
        <>
          <text
            x={center} y={center - 1}
            textAnchor="middle"
            dominantBaseline="middle"
            fontSize={fontSize}
            fontWeight="700"
            fill={color}
          >
            {score}
          </text>
          <text
            x={center} y={center + fontSize * 0.8}
            textAnchor="middle"
            dominantBaseline="middle"
            fontSize={gradeSize}
            fontWeight="600"
            fill="#94a3b8"
          >
            {grade}
          </text>
        </>
      )}
    </svg>
  );
}
